import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { makeStyles } from '@material-ui/core/styles';
import colors from '../../foundations/colors.module.scss';
import { baseMenuItemStyles } from '../Menu/Menu.styles';
const isMultiline = (p)=>p.variant === 'multiline';
export const useMenuItemStyles = makeStyles({
    root: _object_spread_props(_object_spread({}, baseMenuItemStyles), {
        height: (p)=>isMultiline(p) ? 'auto' : p.height || 40,
        whiteSpace: (p)=>isMultiline(p) ? 'normal' : 'nowrap',
        display: (p)=>isMultiline(p) ? 'block' : 'flex'
    }),
    secondary: {
        color: "".concat(colors.dark700, " !important"),
        '&:hover': {
            color: "".concat(colors.dark900, " !important")
        },
        // Target Material-UI Typography
        '& .MuiTypography-root': {
            color: 'inherit !important'
        },
        // Target custom Typography component - force all children to inherit color
        // This ensures Typography components always inherit the menu item color
        '& > *': {
            color: 'inherit !important'
        }
    },
    error: {
        color: "".concat(colors.red950, " !important"),
        '&:hover': {
            color: "".concat(colors.red970, " !important")
        },
        // Beat DropdownMenu's `.menu-X .MuiMenuItem-root.Mui-disabled` (specificity 0,3,0) — keep red, muted, when disabled.
        '&&.MuiMenuItem-root.Mui-disabled': {
            color: "".concat(colors.red700, " !important")
        },
        // Target Material-UI Typography
        '& .MuiTypography-root': {
            color: 'inherit !important'
        },
        // Target custom Typography component - force all children to inherit color
        // This ensures Typography components always inherit the menu item color
        '& > *': {
            color: 'inherit !important'
        }
    }
});
